import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "font-bold text-red-600"
};
const _hoisted_2 = {
  class: "font-bold text-green-600"
};
const _hoisted_3 = {
  class: "-mx-4"
};
const _hoisted_4 = {
  class: "flex flex-col items-center text-center p-4 -mx-12"
};
const _hoisted_5 = {
  class: "font-bold text-xl"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  class: "font-bold text-lg text-green-300"
};
import { Team } from "@/modules/team/entity";
import { app } from "@/di";
import GateManager from "@/modules/action-points/services/GateManager";
import { GateTypeEnum } from "@/modules/action-points/enums";
import { EventEmitter } from "@/modules/base/events";
import AfterCurrencyChangeEvent from "@/modules/action-points/ events/AfterCurrencyChangeEvent";
import CoinsCurrencyExchanger from "@/modules/action-points/services/CoinsCurrencyExchanger";
import { TYPES } from "@/modules/action-points/types";
import Icon from "@/modules/vue/components/Icon.vue";
import Stepper from "@/modules/vue/components/Stepper.vue";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
import ConfirmationButton from "@/modules/vue/components/ConfirmationButton.vue";
import TabbedModal from "@/modules/vue/components/TabbedModal.vue";
import SlideSelect from "@/modules/vue/components/SlideSelect.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangeActionSheet',
  props: {
    type: null
  },
  async setup(__props, {
    expose
  }) {
    let __temp, __restore;
    const props = __props;
    const coinsGate = ref(app.get(GateManager).getGate(GateTypeEnum.COINS));
    const team = ref();
    const currentCoins = ref();
    const balance = ref();
    const exchange = ref(0);
    const products = ref();
    const selectedProduct = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      if (team.value && props.type) {
        currentCoins.value = await coinsGate.value.currency.get();
        balance.value = await app.get(GateManager).getGate(props.type).currency.get();
      }
      products.value = await app.get(TYPES.CoinsSeller).getProducts();
    })), __temp = await __temp, __restore(), __temp);
    onMounted(() => selectedProduct.value = products.value[0]);
    const gainBalance = computed(() => exchange.value * 100);
    onBeforeUnmount(app.get(EventEmitter).onOff([AfterCurrencyChangeEvent], refresh));
    const message = useMessage();
    const onExchange = async () => {
      await app.get(CoinsCurrencyExchanger).exchange(team.value, exchange.value, props.type);
      message.success(translator.t('done'));
      await hide();
    };
    const onBuyCoins = async () => {
      await app.get(TYPES.CoinsSeller).buy(selectedProduct.value);
      await coinsGate.value.currency.add(selectedProduct.value.coins);
      message.success(translator.t('done'));
      await hide();
    };
    const modal = ref(null);
    const show = async () => {
      team.value = await Team.current();
      await refresh();
      modal.value.show();
    };
    const hide = () => modal.value.hide();
    expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(TabbedModal, {
        ref_key: "modal",
        ref: modal,
        tabs: _ctx.$config('coins.enabled') ? ['exchange', 'coins'] : ['exchange'],
        "footer-with-x": ""
      }, {
        "tab:exchange:label": _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('exchange')), 1)]),
        "tab:exchange:content": _withCtx(() => [_createVNode(FormGroup, {
          label: _ctx.$t('coins')
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(currentCoins.value) + " ", 1), _createElementVNode("span", _hoisted_1, " - " + _toDisplayString(_ctx.$n(exchange.value)), 1)])]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('coins')
        }, {
          default: _withCtx(() => [_createVNode(Stepper, {
            modelValue: exchange.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => exchange.value = $event),
            min: 0,
            max: currentCoins.value
          }, null, 8, ["modelValue", "max"])]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: __props.type
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(Math.floor(balance.value)) + " ", 1), _createElementVNode("span", _hoisted_2, " + " + _toDisplayString(_ctx.$n(_unref(gainBalance))), 1)])]),
          _: 1
        }, 8, ["label"])]),
        "tab:exchange:footer": _withCtx(() => [_createVNode(ConfirmationButton, {
          type: "success",
          "no-content": "",
          disabled: exchange.value < 1,
          "no-reset": ""
        }, {
          default: _withCtx(({
            confirmed,
            type,
            label,
            attrs
          }) => [_createVNode(_component_NButton, _mergeProps(attrs, {
            type: type,
            onClick: onExchange
          }), {
            default: _withCtx(() => [!confirmed ? (_openBlock(), _createBlock(Icon, {
              key: 0,
              icon: _ctx.IconEnum.ArrowsHorizontal
            }, null, 8, ["icon"])) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createTextVNode(_toDisplayString(label), 1)], 64))]),
            _: 2
          }, 1040, ["type"])]),
          _: 1
        }, 8, ["disabled"])]),
        "tab:coins:label": _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('buy_coins')), 1)]),
        "tab:coins:content": _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(SlideSelect, {
          modelValue: selectedProduct.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectedProduct.value = $event),
          items: products.value,
          class: "bg-slate-500 text-slate-50"
        }, {
          item: _withCtx(({
            item
          }) => [_createElementVNode("div", _hoisted_4, [_createVNode(Icon, {
            icon: _ctx.IconEnum.Coins,
            class: "text-gold-500 mb-2"
          }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1), item.description ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.description), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$money(item.price)), 1)])]),
          _: 1
        }, 8, ["modelValue", "items"])])]),
        "tab:coins:footer": _withCtx(() => [_createVNode(_component_NButton, {
          type: "success",
          onClick: onBuyCoins
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.Coins,
            class: "mr-2"
          }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_ctx.$t('buy_coins')), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["tabs"]);
    };
  }
});